import { motion, useReducedMotion } from "framer-motion";
import { Breadcrumbs } from "./Breadcrumbs";

type Props = { eyebrow: string; title: string; text?: string; crumb: string; testId: string };

export const PageHeader = ({ eyebrow, title, text, crumb, testId }: Props) => {
  const reduce = useReducedMotion();
  return (
    <header className="container-x pt-32 md:pt-40 pb-12 md:pb-16" data-testid={testId}>
      <Breadcrumbs items={[{ label: crumb }]} />
      <div className="mt-8 grid gap-6 lg:grid-cols-12">
        <motion.div className="lg:col-span-8" initial={{ opacity: 0, y: reduce ? 0 : 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="h1 mt-4">{title}</h1>
        </motion.div>
        {text && (
          <motion.p className="lede lg:col-span-4 lg:self-end" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7, delay: 0.2 }}>
            {text}
          </motion.p>
        )}
      </div>
    </header>
  );
};
